import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon", "button"]

  connect() {
    this.updateAriaExpanded()
  }

  toggle(event) {
    // Support keyboard activation
    if (event && event.type === 'keydown') {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return
      }
      event.preventDefault()
    }

    const isHidden = this.menuTarget.classList.contains("hidden")
    
    this.menuTarget.classList.toggle("hidden")
    this.openIconTarget.classList.toggle("hidden")
    this.closeIconTarget.classList.toggle("hidden")
    
    this.updateAriaExpanded()
    
    // Set aria-hidden on menu
    this.menuTarget.setAttribute("aria-hidden", !isHidden)
    
    // If opening, focus first menu item
    if (isHidden) {
      requestAnimationFrame(() => {
        const firstLink = this.menuTarget.querySelector('a, button')
        if (firstLink) {
          firstLink.focus()
        }
      })
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    this.updateAriaExpanded()
    this.menuTarget.setAttribute("aria-hidden", "true")
  }

  // Close on Escape key
  keydown(event) {
    if (event.key === "Escape") {
      this.close()
      // Return focus to toggle button
      if (this.hasButtonTarget) {
        this.buttonTarget.focus()
      }
    }
  }

  updateAriaExpanded() {
    const isOpen = !this.menuTarget.classList.contains("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", isOpen)
    }
  }
}
